const Form054EN = {
    stepName: {
        Statement: "Important Notes",
        SelectForm: "Selection of Cash Grant for Therapist(s)",
        SchoolInfo: "Basic Information",
        SelectPart: "Selection of Section(s)",
        SectionA: "Section A",
        SectionB: "Section B",
        Certification: "Certification",
        Confirmation: "Confirmation",
    },
    label: {
        applyFormOption: {
            CGOT: "Cash Grant for Occupational Therapist (CGOT) in Aided Special Schools",
            CGPT: "Cash Grant for Physiotherapist (CGPT) in Aided Special Schools",
            CGST: "Cash Grant for Speech Therapist (CGST) in Aided Special Schools",
        },
        applyPartOption: {
            PartA: "Section A {{shortName}} in exchange for one/two vacant {{fullName}}",
            PartB: "Section B {{shortName}} in lieu of temporary replacement for {{abbName}} on approved leave of not less than 30 days",
        },
        NROption: {
            N: "New Claim Post",
            R: "Revised Claim",
        },
        changePreClaimOption: {
            unDelete: "Unchange Previous Claim",
            delete: "Delete Previous Claim",
            change: "Change previous claim",
        },
        OTRankOption: {
            SOT: "Senior Occupational Therapist",
            OTI: "Occupational Therapist I",
        },
        OTRankOptionPartB: {
            SOT: "Senior Occupational Therapist",
            OTI: "Occupational Therapist I",
            OTII: "Occupational Therapist II",
        },
        PTRankOption: {
            SPT: "Senior Physiotherapist",
            PTI: "Physiotherapist I",
        },
        PTRankOptionPartB: {
            SPT: "Senior Physiotherapist",
            PTI: "Physiotherapist I",
            PTII: "Physiotherapist II",
        },
        salaryList: {
            pt34: "74515",
            pt25: "51095",
            pt19: "38595",
            pt26: "53500",
        },

        shortName: {
            CGOT: "OT",
            CGPT: "PT",
            CGST: "ST",
        },
        fullName: {
            CGOT: "Occupational Therapist (OT) post(s)",
            CGPT: "Physiotherapist (PT) post(s)",
            CGST: "Speech therapist (ST) post(s)",
        },
        rankOption: {
            CGOT: "and select the rank",
            CGPT: "and select the rank",
            CGST: "",
        },

        statement: "Personal Information Collection Statement",
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        statementTwo:
            "I understand the applicant and the teacher need to have an “iAM Smart+” account to process the application.",
        applyTitle: "Please select:",
        noteTitle: "Note",
        previousDate: "Copy of Previous Claim Dated:",
        headerTitleOne: "Basic Information",
        headerTitleTwo:
            "{{formName}} in Exchange for One/Two Vacant {{fullPostName}} ({{postName}}) Post(s)",

        head1: "To :",
        head2: "Recurrent Subventions Section, Education Bureau",
        head3: "[Attn.: AOI(RS)]",
        schoolName: "Name of School",
        schoolCode: "School Code",
        Month: "Month",
        Year: "Year",

        postRank: "Rank of the Vacant Post for Cash Grant",
        vacantPostNum:
            "Number of the Vacant Post frozen for application of Cash Grant",
        NR: "N: New Claim Post/R: Revised Claim",
        changePreclaim:
            "Unchange previous claim/Delete previous claim/Change previous claim:",
        preclaimNum:
            "Please indicate the Application Number of Previous Claim Form",
        applicationNum: "Application Number",
        startDate: "Revocable Freezing of Vacancy of Period from",
        endDate: "Revocable Freezing of Vacancy of Period to",
        leaveStartTime: "Leave Period From",
        leaveEndTime: "Leave Period To",
        qualifiedStartTime: "Qualified Period From",
        qualifiedEndTime: "Qualified Period To",
        qualifiedMonth: "(a) Number of Qualified Months",
        monthlySalary: "(b) Monthly Salary",
        MPFSubsidy: "(c) MPF Subsidy",
        Amount: "{{formName}} Amount",
        amountTip:
            "{{formName}} Amount = SUM of (Number of the vacant post for cash grant x Number of Qualified Months(each month) x Monthly Salary(each month) + capped MPF Subsidy(each month));",
        previousFormFile: "A Copy of Previous Claim:",
        headerTitleThree:
            "{{formName}} in lieu of Temporary Replacement for {{postName}} on Approved Leave of not less than 30 days",
        temporaryStaffFormTitleOne:
            "Information of the {{postName}}(s) on Leave",
        temporaryStaffFormTitleTwo: "Information for {{formName}}",
        staffName: "Name",
        SRN: "SRN",
        Rank: "Rank",
        MPFFile: "MPF Supporting Information:",
        absenceReason: "Reason for Absence",
        total: "Total",

        signName: "Name of Supervisor/School Head",
        signDate: "Date",
        signContactPerson: "Contact Person",
        signTelNo: "Tel No.",
        signSsdo: "SSDO",

        postNum: "Number of Posts",
    },
    labelStep: [
        { step: "(i)" },
        { step: "(ii)" },
        { step: "(iii)" },
        { step: "(iv)" },
    ],

    noteList: {
        STnoteOne:
            "Schools with less than 4 ST posts in the staff establishment can freeze and encash one ST vacant post while schools with 4 ST posts or more in the staff establishment can freeze and encash a maximum of two ST vacant posts in a school year;",
        noteOne:
            "A maximum of two {{postName}} vacant posts can be frozen and encashed in a school year;",
        noteTwo:
            "Calculate the number of qualified months from the starting date to the ending date (both dates inclusive) for {{formName}} by adding up the following 3 elements:",
        noteTwoA: [
            {
                text: "the proportion of qualified number of days, if any, in the starting month to its total number of calendar days;",
            },
            {
                text: "number of completed calendar months, if any; and",
            },
            {
                text: "the proportion of qualified number of days, if any, in the ending month to its total number of calendar days.",
            },
        ],
        ExampleOne:
            "Assuming the Qualified Period for {{formName}} starts from 5 February to 26 May, the Number of Qualified Months should be calculated as follows:",
        noteTwoB: [
            {
                text: "24 being number of days in the starting month (5 to 28 February) divided by 28 (the total number of days in February) = 0.857 months;",
            },
            {
                text: "2 being number of completed calendar months of March and April;",
            },
            {
                text: "26 being number of days in the ending month (1 to 26 May) divided by 31 (being the total number of days in May) = 0.839 months; and",
            },
            {
                text: "The Number of Qualified Months should be the sum of the above 3 elements (rounded at 3 decimals), i.e. 0.857 + 2 + 0.839 = 3.696.",
            },
        ],
        STnoteThree:
            "Enter the mid-point salary of ST which is at Master Pay Scale point 26.",
        noteThreeA:
            "Enter the starting salary point of {{postName}} I / S{{postName}}, if applicable.  The starting salaries of {{postName}} I and S{{postName}} are at MPS Point 25 and 34 respectively.",
        noteThreeB:
            "Auto-fill the mid-point salary of the {{postName}} II post or the starting salary point of {{postName}} I / S{{postName}}, if applicable.  The mid-point salary of an {{postName}} II is at Master Pay Scale (MPS) Point 19 , and the starting salaries of {{postName}} I and S{{postName}} are at MPS Point 25 and 34 respectively.",
        noteFour:
            "Employer's contribution to MPF Schemes (5% of the monthly salary capped at maximum amount stipulated under prevailing MPF regulations) will be included if the qualified period is of 60 days or more. For encashment for a period of less than 60 calendar days for freezing of vacant {{postName}} or temporary replacement for {{postName}} on approved leave, and the contribution to MPF Schemes is required, please provide supporting information.",
        noteFive:
            "Enter Staff Reference Number {{rank}} of the {{postName}} on leave.",
        noteSix:
            "Please note that granting of leave must follow EDB Circular No. 1/2006.",
    },
    certifyList: {
        cNote: "I certify that:",
        cTwo: "consent has been obtained from my school’s SMC/IMC and the majority of {{postName}}(s) for freezing the {{postName}} post(s) under Section A in the above-mentioned period in the school year;",
        cThree: "(<i>for revocable freezing or temporary replacement of promotion rank, i.e. {{postName}} I/S{{postName}}</i>) the school has proven genuine need for the encashment of the promotion rank;",
        cFour: "the frozen {{postName}} post(s) claiming {{formName}} under Section A arises from vacant regular post(s) during the claim period and this request for payment complies with the conditions set out for {{formName}} applications;",
        cFive: "no duplicate claim has been made for government subventions on account of the same frozen period / leave set out above; and",
        cSix: "My school will refund to the Education Bureau any over-payment of grant.",
    },

    errorMsg: {
        "E-0008": "The input content format is incorrect",
        freezDateRuls: "Period of Freezing of Vacancy (not less than 30 days)",
        freezVacancy:
            "Revocable Freezing of Vacancy of Period must not be less than 30 calendar days",
        leavePeriod: "Leave Period must not be less than 30 calendar days",
        qualifiedPeriod:
            "Qualified Period must not be less than 30 calendar days",
        limitsEndDateRuls:
            "The above date cannot be later than 31 Aug of the respective school year.",
        leaveDateRuls: "The Leave Period is not less than 30 days",
        postNumLimit:
            "The sum of the number of vacant positions cannot be greater than 2",
        withinLimit: "The Qualified Period should be within the Leave Period",
        // qualifiedDateRules:
        //     "qualifying period (not less than 30 days), and the deadline shall not be later than August 31",
    },
};
export default Form054EN;
